export var Collision;
(function (Collision) {
    Collision["fit"] = "fit";
    Collision["flip"] = "flip";
    Collision["none"] = "none";
})(Collision || (Collision = {}));



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/collision.js
// module id = 342
// module chunks = 93